import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { CATEGORY_LABELS, MODULE_LABELS } from "@/lib/strings";

export function VersionsTable({ versions }) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-0 overflow-x-auto">
        <Table data-testid="versions-table">
          <TableHeader>
            <TableRow>
              <TableHead>Standard</TableHead><TableHead>Versione</TableHead><TableHead>Data</TableHead>
              <TableHead>Stato</TableHead><TableHead>Disclosure</TableHead><TableHead>Datapoint</TableHead>
              <TableHead>Regole applicabilità</TableHead><TableHead>Regole validazione</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {versions.map((v) => (
              <TableRow key={v.id} data-testid={`version-row-${v.version_name.slice(0, 12)}`}>
                <TableCell className="font-medium">{v.standard_code}</TableCell>
                <TableCell>{v.version_name}</TableCell>
                <TableCell>{v.version_date}</TableCell>
                <TableCell>
                  <Badge variant="outline" className="bg-green-50 text-green-800 border-green-300">{v.status}</Badge>
                </TableCell>
                <TableCell>{v.disclosures_count}</TableCell>
                <TableCell>{v.datapoints_count}</TableCell>
                <TableCell>{v.applicability_rules_count}</TableCell>
                <TableCell>{v.validation_rules_count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export function DisclosuresTable({ disclosures }) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-0 overflow-x-auto">
        <Table data-testid="disclosures-table">
          <TableHeader>
            <TableRow>
              <TableHead>Codice</TableHead><TableHead>Titolo</TableHead><TableHead>Modulo</TableHead>
              <TableHead>Area</TableHead><TableHead>Applicabilità</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {disclosures.map((d) => (
              <TableRow key={d.id} data-testid={`admin-disclosure-${d.disclosure_code.toLowerCase()}`}>
                <TableCell className="font-bold">{d.disclosure_code}</TableCell>
                <TableCell className="max-w-md">{d.title}</TableCell>
                <TableCell>{MODULE_LABELS[d.module]}</TableCell>
                <TableCell>{CATEGORY_LABELS[d.category]}</TableCell>
                <TableCell>{d.applicability_type}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export function DatapointsTable({ datapoints }) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-0 overflow-x-auto">
        <Table data-testid="datapoints-table">
          <TableHeader>
            <TableRow>
              <TableHead>Codice</TableHead><TableHead>Etichetta</TableHead><TableHead>Tipo dato</TableHead>
              <TableHead>Unità</TableHead><TableHead>Obbligatorietà</TableHead><TableHead>XBRL</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {datapoints.map((dp) => (
              <TableRow key={dp.datapoint_code}>
                <TableCell className="font-mono text-xs">{dp.datapoint_code}</TableCell>
                <TableCell className="max-w-xs">{dp.label}</TableCell>
                <TableCell><Badge variant="outline" className="bg-slate-50 text-[11px]">{dp.data_type}</Badge></TableCell>
                <TableCell>{dp.unit || "—"}</TableCell>
                <TableCell>{dp.required_type}</TableCell>
                <TableCell className="text-xs text-slate-500">{dp.xbrl_tag || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export function ApplicabilityRulesTable({ rules }) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-0 overflow-x-auto">
        <Table data-testid="applicability-rules-table">
          <TableHeader>
            <TableRow>
              <TableHead>Codice regola</TableHead><TableHead>Descrizione</TableHead>
              <TableHead>Condizione</TableHead><TableHead>Risultato</TableHead><TableHead>Target</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rules.map((r) => (
              <TableRow key={r.id}>
                <TableCell className="font-mono text-xs">{r.rule_code}</TableCell>
                <TableCell className="max-w-md text-sm">{r.description}</TableCell>
                <TableCell className="font-mono text-xs">
                  {r.condition_definition?.datapoint_code} {r.condition_definition?.operator}{" "}
                  {JSON.stringify(r.condition_definition?.value)}
                </TableCell>
                <TableCell><Badge variant="outline" className="bg-slate-50">{r.result}</Badge></TableCell>
                <TableCell className="font-mono text-xs max-w-xs">{(r.targets || []).join(", ")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export function ValidationRulesTable({ rules }) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-0 overflow-x-auto">
        <Table data-testid="validation-rules-table">
          <TableHeader>
            <TableRow>
              <TableHead>Codice regola</TableHead><TableHead>Tipo</TableHead><TableHead>Datapoint</TableHead>
              <TableHead>Condizione</TableHead><TableHead>Severità</TableHead><TableHead>Messaggio</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rules.map((r) => (
              <TableRow key={r.id}>
                <TableCell className="font-mono text-xs">{r.rule_code}</TableCell>
                <TableCell>{r.validation_type}</TableCell>
                <TableCell className="font-mono text-xs">{r.datapoint_code}</TableCell>
                <TableCell className="font-mono text-xs">{JSON.stringify(r.condition_definition)}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={
                    r.severity === "ERROR" || r.severity === "BLOCKING"
                      ? "bg-red-50 text-red-800 border-red-200"
                      : "bg-amber-50 text-amber-800 border-amber-200"
                  }>{r.severity}</Badge>
                </TableCell>
                <TableCell className="max-w-xs text-sm">{r.error_message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
